import Skeleton from "components/Skeleton"
import Button from "components/Button"
import Modal from "./Modal"

interface FromQrModalProps {
  name: string | undefined
  gender: string | undefined
  age: number | string | undefined
  isLoading: boolean
  onClose: () => void
  setModal: (modaltype: string) => void
}

const FromQrModal: React.FC<FromQrModalProps> = ({ age, name, gender, isLoading, onClose, setModal }) => {
  return (
    <Modal
      onClose={onClose}
      title={isLoading ? 'Ładowanie...' : name ? name : ''}
      topSubtitle={isLoading ? 'Ładowanie...' : age ? `Żył${gender === 'female' ? 'a' : ''} lat ` + age : undefined}>
      {isLoading
        ? <Skeleton type="modalFromQr" />
        : <div className="modal__fromQr">
          <h2>Wybierz co chcesz zrobić</h2>
          <Button type={'secondary'} icon="candle" text="Zapal znicz" action={() => setModal('candle')} />
          <Button type={'secondary'} icon="book" text="Dodaj wpis do księgi" action={() => setModal('post')} />
          <Button type={'primary'} text="Obejrzyj profil" action={onClose} />
        </div>
      }
    </Modal>)
}

export default FromQrModal